import { Manufacturer } from '@domain'

import api from '.'
import { ManufacturersReq } from './manufacturers.types'

export const ManufacturersKey = {
	all: ['manufacturers'],
	list: (query: ManufacturersReq) => [...ManufacturersKey.all, query],
}

const ManufacturersApi = {
	list: (query: ManufacturersReq) =>
		api
			.get<PaginatedAPIRes<Manufacturer[]>>(`/manufacturers`, { params: query })
			.then((res) => res.data),
}

export default ManufacturersApi
